// REA-CI/screens/VerificationScreen.tsx

import React, { useState, useEffect } from "react";
import {
  View,
  Text,
  TouchableOpacity,
  StyleSheet,
  Alert,
  Image,
  Platform,
} from "react-native";
import * as ImagePicker from "expo-image-picker";
import { useNavigation } from "@react-navigation/native";
import { RootStackParamList, StackNavigationProp } from "../navigation/types";

type VerificationScreenNavigationProp = StackNavigationProp<
  RootStackParamList,
  "VerificationScreen"
>;

const VerificationScreen = () => {
  const navigation = useNavigation<VerificationScreenNavigationProp>();
  const [selectedImage, setSelectedImage] = useState<string | null>(null);

  const pickImage = async () => {
    if (Platform.OS === "web") {
      // Handle image picking for the web using a regular HTML file input
      const fileInput = document.createElement("input");
      fileInput.type = "file";
      fileInput.accept = "image/*";
      fileInput.onchange = (e: any) => {
        const file = e.target.files[0];
        if (file) {
          const reader = new FileReader();
          reader.onloadend = () => {
            setSelectedImage(reader.result as string);
          };
          reader.readAsDataURL(file);
        }
      };
      fileInput.click();
    } else {
      // Handle image picking for mobile platforms (iOS/Android)
      try {
        const permissionResult = await ImagePicker.requestMediaLibraryPermissionsAsync();

        if (!permissionResult.granted) {
          Alert.alert(
            "Permission Denied",
            "We need access to your photos to continue."
          );
          return;
        }

        const result = await ImagePicker.launchImageLibraryAsync({
          mediaTypes: ImagePicker.MediaTypeOptions.Images, // Correct media type
          allowsEditing: true,
          aspect: [4, 3],
          quality: 1,
        });

        if (!result.cancelled && result.assets?.length > 0) {
          setSelectedImage(result.assets[0].uri); // Use the correct URI
        } else {
          Alert.alert("No Image Selected", "You did not select any image.");
        }
      } catch (error) {
        console.error("Error picking image:", error); // Log the error for debugging
        Alert.alert("Error", "An error occurred while picking the image.");
      }
    }
  };

  const handleVerify = () => {
    if (selectedImage) {
      Alert.alert("Verification Submitted", "Your image is under review.");
      navigation.navigate("SellerHomeScreen"); // Navigate to SellerHomeScreen
    } else {
      Alert.alert("Error", "Please upload an image for verification.");
    }
  };

  return (
    <View style={styles.container}>
      <Text style={styles.title}>Upload Your ID or Passport</Text>

      <TouchableOpacity style={styles.uploadButton} onPress={pickImage}>
        <Text style={styles.buttonText}>Choose Photo</Text>
      </TouchableOpacity>

      {selectedImage && (
        <Image source={{ uri: selectedImage }} style={styles.previewImage} />
      )}

      <TouchableOpacity style={styles.submitButton} onPress={handleVerify}>
        <Text style={styles.buttonText}>Submit for Verification</Text>
      </TouchableOpacity>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#ffffff",
    padding: 20,
  },
  title: {
    fontSize: 24,
    fontWeight: "bold",
    marginBottom: 20,
    textAlign: "center",
  },
  uploadButton: {
    backgroundColor: "#007BFF",
    paddingVertical: 15,
    paddingHorizontal: 30,
    borderRadius: 5,
    marginVertical: 10,
  },
  previewImage: {
    width: 200,
    height: 200,
    borderRadius: 10,
    marginVertical: 20,
  },
  submitButton: {
    backgroundColor: "#28a745",
    paddingVertical: 15,
    paddingHorizontal: 30,
    borderRadius: 5,
    marginTop: 20,
  },
  buttonText: {
    color: "#ffffff",
    fontSize: 16,
    fontWeight: "bold",
  },
});

export default VerificationScreen;
